"use strict";

var _createForOfIteratorHelper = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("unorm");

var idna_uts46_hx_1 = require("idna-uts46-hx");

var crypto_1 = require("../crypto");

var hex_1 = require("../hex");

var constatnts_1 = require("./constatnts");

function normalizeEnsName() {
  var result = null;

  for (var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++) {
    parts[_key] = arguments[_key];
  }

  var name = parts.filter(function (part) {
    return !!part;
  }).join(constatnts_1.ENS_NAME_SEPARATOR).split(constatnts_1.ENS_NAME_SEPARATOR).map(function (part) {
    return part.toLowerCase().trim();
  }).filter(function (part) {
    return !!part;
  }).join(constatnts_1.ENS_NAME_SEPARATOR);

  if (name) {
    try {
      name = idna_uts46_hx_1.toAscii(name.toLowerCase(), {
        transitional: true,
        useStd3ASCII: true
      });
    } catch (err) {
      name = null;
    }

    if (name) {
      result = name;
    }
  }

  return result;
}

exports.normalizeEnsName = normalizeEnsName;

function getEnsNameInfo() {
  var result = null;
  var name = normalizeEnsName.apply(void 0, arguments);

  if (name) {
    result = {
      name: name,
      nameHash: getEnsNameHash(name),
      label: null,
      labelHash: null,
      rootNode: null
    };
    var parts = name.split(constatnts_1.ENS_NAME_SEPARATOR);

    if (parts.length > 1) {
      var label = parts[0];

      var _name = parts.slice(1).join(constatnts_1.ENS_NAME_SEPARATOR);

      if (label && _name) {
        result = Object.assign({}, result, {
          label: label,
          labelHash: getEnsLabelHash(label),
          rootNode: {
            name: _name,
            nameHash: getEnsNameHash(_name)
          }
        });
      }
    }
  }

  return result;
}

exports.getEnsNameInfo = getEnsNameInfo;

function getEnsNameHash(name) {
  var result = null;

  if (name) {
    var node = Buffer.alloc(32, 0);
    var parts = name.split(constatnts_1.ENS_NAME_SEPARATOR).map(function (part) {
      return crypto_1.sha3(part);
    }).reverse();

    var _iterator = _createForOfIteratorHelper(parts),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var part = _step.value;
        node = crypto_1.sha3(node, part);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    result = hex_1.anyToHex(node, {
      add0x: true
    });
  }

  return result;
}

exports.getEnsNameHash = getEnsNameHash;

function getEnsLabelHash(label) {
  var result = null;

  if (label) {
    result = hex_1.anyToHex(crypto_1.sha3(label), {
      add0x: true
    });
  }

  return result;
}

exports.getEnsLabelHash = getEnsLabelHash;